import Unsupported from './unsupported';
import './unsupported.scss';

export default Unsupported;
